import { NPSAreasEnum } from './nps-areas.enum';

export const NPSAreas: { value: NPSAreasEnum; text: string }[] = [
  { value: NPSAreasEnum.Promoters, text: 'Promoters' },
  { value: NPSAreasEnum.Passives, text: 'Passives' },
  { value: NPSAreasEnum.Detractors, text: 'Detractors' }
];
